import React from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import CustomPagination from "../../pagination/custom-pagination";
import HandleAdvanceTableData from "./handle-data";
// import HandleAdvanceTableData from "./handle-data";
import "./styles.scss";
import DataTableActions from "./table-actions";

export default function AdvanceDataTable(props) {
  const handleRowClick = (index) => {
    if (props.expandable && props.handleRowClick) {
      props.handleRowClick(index);
    }
  };

  return (
    <div className="ss-advance-data-table">
      <div className="table-responsive " style={{ overflowY: "auto" }}>
        <PerfectScrollbar className="scroll" style={{ maxHeight: "calc(100vh - 240px)", position: "relative" }} options={{ wheelSpeed: 0.4 }}>
          <table className="table table-hover align-middle table-row-dashed dataTable no-footer" style={{ fontSize: "1.075rem" }}>
            <thead>
              <tr className="fw-bolder text-muted">
                {props.columns.map((each, index) => {
                  return (
                    <th key={index} className="cursor-pointer pt-0 bg-white color-black top-0 position-sticky" style={{ minWidth: `${100 / props.columns.length}%`, whiteSpace: "nowrap", zIndex: 1 }}>
                      <div className={`d-flex flex-row w-100 h-100 gap-3 align-items-center ${each.isFixed ? "table-action-wrapper" : ""}`} style={{ color: "black", opacity: 0.8, whiteSpace: "nowrap" }}>
                        {each.title}
                      </div>
                    </th>
                  );
                })}
              </tr>
            </thead>
            <tbody>
              {props.data.map((data, rowIndex) => {
                return (
                  <>
                    <tr key={rowIndex} onClick={() => handleRowClick(rowIndex)}>
                      {props.columns.map((col, index) => (
                        <td style={{ whiteSpace: "nowrap" }} key={index}>
                          {col.isAction ? (
                            <DataTableActions
                              options={col.options}
                              data={data}
                              handleReport={props.handleReport}
                              handleEdit={props.handleEdit}
                              handleEnter={props.handleEnter}
                              handleDelete={props.handleDelete}
                              handleOnChoose={props.handleOnChoose}
                              handleDownload={props.handleDownload}
                            />
                          ) : (
                            <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
                              <HandleAdvanceTableData
                                keyIndex={`${rowIndex}-${index}`}
                                data={data}
                                value={data[col.apiKeyName]}
                                showDownloadIcon={false}
                                field={col}
                                type={col.fieldInputType}
                                onStatusChange={(checked) => {
                                  if (props.onStatusChange) {
                                    props.onStatusChange(data._id, checked);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </td>
                      ))}
                    </tr>
                    {props.expandable && props.expandableIndex === rowIndex && (
                      <tr>
                        <td className="bg-light-light" colSpan={props.columns.length}>
                          {props.expandableComponent}
                        </td>
                      </tr>
                    )}
                  </>
                );
              })}
            </tbody>
          </table>
        </PerfectScrollbar>
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          paddingTop: 7,
          gap: 15,
          justifyContent: "flex-end",
        }}
        className="px-3"
      >
        <p style={{ fontSize: "1.075rem", marginTop: 5, marginBottom: 0 }}>
          Showing {(props.pageNo - 1) * props.limit + 1}-{props.count > props.pageNo * props.limit ? props.pageNo * props.limit : props.count} of {props.count}
        </p>
        {CustomPagination(props.pageNo, props.setPageNo, Math.ceil(props.count / props.limit), () => {}, props.limit, props.setLimit)}
      </div>
    </div>
  );
}
